module.exports = __webpack_public_path__ + "img/support_yy_03@2x.7933fc6a.png";